// #ux-redesign-start: toolbar contextual del inbox-main.
// Patients no tiene folders/papelera (Move/Restore/PermanentDelete del backend
// no están declarados en routes/patients.js). Mostramos solo Reply + Delete
// (soft). El botón "Nuevo mensaje" vive en el aside (CTA principal).
// ─────────────────────────────────────────────────────────────────────────────
import React from 'react';
import { useSelector } from 'react-redux';
import BtnReply from './BtnReply';
import BtnDelete from './BtnDelete';

const Actions = ({ setShowForm, mobile, setReply, setResend }) => {
  const { message } = useSelector((state) => state.messagesReducer);
  const disabled = !message;

  return (
    <div className={mobile ? 'btn-group-inbox' : 'text-right'}>
      <BtnReply
        mobile={mobile}
        setShowForm={setShowForm}
        setReply={setReply}
        setResend={setResend}
        disabled={disabled}
      />
      <BtnDelete mobile={mobile} setShowForm={setShowForm} />
    </div>
  );
};

export default Actions;
// #ux-redesign-end
